import React from "react";

// tslint:disable: max-line-length
interface Props {
  width?: number;
  height?: number;
}
export default function Alerte(props: Props) {
  return (
    <svg
      width={props.width ? props.width + "px" : "25.674px"}
      height={props.height ? props.height + "px" : "28.008px"}
      viewBox="0 0 25.674 28.008"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="BOARD-3---Icônes" transform="translate(0)">
        <g id="Pictogrammes">
          <g id="_15---Notifications" data-name="15---Notifications">
            <path
              id="Combined-Shape"
              d="M12.837,2a.876.876,0,0,1,.875.875V5.548a8.181,8.181,0,0,1,7.293,8.122v3.254A7.819,7.819,0,0,0,23.781,22.9a2.041,2.041,0,0,1-1.316,3.6H17.125a4.377,4.377,0,0,1-8.576,0H3.209a2.043,2.043,0,0,1-1.328-3.594,7.821,7.821,0,0,0,2.787-5.989V13.67a8.181,8.181,0,0,1,7.294-8.122V2.875A.876.876,0,0,1,12.837,2Zm2.476,24.508H10.361a2.626,2.626,0,0,0,4.951,0ZM12.837,7.251A6.425,6.425,0,0,0,6.418,13.67v3.254a9.564,9.564,0,0,1-3.4,7.317.291.291,0,0,0-.105.224.3.3,0,0,0,.292.292H22.465a.3.3,0,0,0,.292-.292.288.288,0,0,0-.1-.222,9.567,9.567,0,0,1-3.4-7.319V13.67A6.425,6.425,0,0,0,12.837,7.251ZM21.488,3.56A14.207,14.207,0,0,1,25.674,13.67a.875.875,0,1,1-1.75,0A12.465,12.465,0,0,0,20.25,4.8.876.876,0,0,1,21.488,3.56Zm-16.063,0a.876.876,0,0,1,0,1.238A12.457,12.457,0,0,0,1.75,13.67a.875.875,0,1,1-1.75,0A14.2,14.2,0,0,1,4.187,3.561.876.876,0,0,1,5.425,3.561Z"
              transform="translate(0 -2)"
              fill="#fd534b"
              fill-rule="evenodd"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
